import { Autocomplete, FormControl, TextField } from "@mui/material"
import React from "react"
import { Arrow, SearchIcon } from "../Icons/Icons"

const SearchAutoComplete = ({
  options,
  label,
  className,
  onChange,
  selectedValue,
  setInputValue,
  setSelectedValue,
  items,
  type
}) => {

  const filteredOptions = options.filter(
    (option) => !items.some((item) => item.label === option.label)
  )

  return (
    <div className={className}>
      <FormControl fullWidth>
        {label && <div className="ml-4 text-[14px] flex justify-start flex-col text-text-secondary mb-2">
          {label}
        </div>}
        <div className="relative">
          {type === 'search' &&
            <div className=" absolute left-0 top-0 mt-4 ml-3.5  ">
              <SearchIcon />
            </div>
          }
          <Autocomplete
            freeSolo
            options={filteredOptions}
            value={selectedValue}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText="No locations"
            onChange={(event, newValue) => {
              setSelectedValue(newValue)
              if (onChange) {
                onChange(newValue)
              }
            }}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue)
            }}
            renderOption={(props, option) => (
              <div {...props}>
                {option?.type === "income" ? <Arrow /> : <Arrow fill="#FF5630" fillBg="#FF563029" isArrowUp={false} />}
                <div className="pl-3">{`${option.category} > ${option.label}`}</div>
              </div>
            )}
            sx={{
              width: "full",
              fieldset: {
                border: "1px solid",
                borderRadius: "8px",
                height: "56px",
                marginTop: "3px",
                borderColor: 'var(--color-divider)',
                "--tw-border-opacity": "1",
                legend: {
                  display: "none",
                },
              },
              div: {
                height: "56px",
              },
              button: {
                marginTop: "12px",
              },
              input: {
                marginLeft: "32px"
              }
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </div>
      </FormControl>
    </div>
  )
}

export default SearchAutoComplete